import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import commonActions from "../redux/common/actions";
import { Box, CircularProgress } from "@mui/material";
import { cssProperties } from "../utils/commonCssProperties";
const SuspenseLoader = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

    return () => {
      dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
    };
  }, [dispatch]);

  return 
  <div>
  <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 9999,
}}>
    <CircularProgress sx={{ color: `${cssProperties?.color?.primary}` }} size={70} thickness={4.5} />
</Box>
</div>
};

export default SuspenseLoader;
